enum LastSyncStatus {
  COMPLETED = "completed",
  COMPLETED_WITH_ERRORS = "completed_with_errors",
  FAILED = "failed",
}

export default LastSyncStatus;
